<template>
  <div id="relatedLoans" style="font-family: 'Montserrat';">
    <v-toolbar color="#F9FAFD" dark class="toolbar-card" style="height: 80px;">
      <v-toolbar-title style="font-size: 24px; font-weight: 600; line-height: 32px; height: 32px; color: #161A40; font-family: 'Montserrat';">Related Loans</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-spacer></v-spacer>
        <v-btn
          @click="sortByCreateTime"
          color="#5C82E3"
          class="m-t-20 m-r-0"
          style="padding: 8px;"
          text
        >
          Create Time
        </v-btn>
        <v-btn
          color="#5C82E3"
          class="m-t-20 m-r-0 p-0"
          icon
        >
          <v-icon
            @click="sortByCreateTime"
          >{{ this.sortTime ? 'mdi-arrow-down' : 'mdi-arrow-up' }}</v-icon>
        </v-btn>
        <v-btn
          color="#5C82E3"
          class="m-t-20 m-r-0 m-l-20"
          style="padding: 8px;"
          text
          @click="sortByLoanStatus"
        >
          Loan Status
        </v-btn>
        <v-btn
          color="#5C82E3"
          class="m-t-20 p-r-0"
          style="margin-right: 24px;"
          icon
        >
          <v-icon
            @click="sortByLoanStatus">{{ this.sortLoanStatus ? 'mdi-arrow-down' : 'mdi-arrow-up' }}</v-icon>
        </v-btn>
      </v-row>
      <related-queue :relatedLoans="relatedLoans"></related-queue>
    </v-container>
  </div>
</template>
<script>
import { Tool } from '@/util/index'
import { LoanOperationApi } from '@/api/pandaria'
import RelatedQueue from '@/components/panda/common/queue/RelatedQueue'

const tool = new Tool()
export default {
  name: 'related-loans',
  // eslint-disable-next-line vue/no-unused-components
  components: { RelatedQueue },
  props: {
    loan: Object
  },
  data () {
    return {
      assist: {
        tool: tool
      },
      sortTime: false,
      sortLoanStatus: false,
      isActive: false,
      relatedLoans: [],
      search: true,
      input: {}
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  watch: {
    isActive () {
      var i = 0
      const tool = new Tool()
      if (tool.isNotEmpty(this.isActive)) {
        const temp = []
        for (const relatedLoan in this.relatedLoans) {
          if (this.relatedLoans[relatedLoan].status < 60000 || this.relatedLoans[relatedLoan].status > 70000) {
            temp[i] = this.relatedLoans[relatedLoan]
            i += 1
          }
        }
        this.relatedLoans = temp
      } else {
        this.relatedLoans = this.$store.getters.getRelatedLoans
      }
      this.$forceUpdate()
    }
  },
  methods: {
    sortByCreateTime () {
      const tool = new Tool()
      const $this = this
      if (tool.isNotEmpty($this.relatedLoans)) {
        $this.relatedLoans.sort(function (a, b) {
          if ($this.sortTime) {
            return a.createdAt - b.createdAt
          } else {
            return b.createdAt - a.createdAt
          }
        })
      }
      $this.sortTime = !($this.sortTime)
      this.$forceUpdate()
    },
    sortByLoanStatus () {
      const tool = new Tool()
      const $this = this
      if (tool.isNotEmpty($this.relatedLoans)) {
        $this.relatedLoans.sort(function (a, b) {
          if ($this.sortLoanStatus) {
            return a.status - b.status
          } else {
            return b.status - a.status
          }
        })
      }
      $this.sortLoanStatus = !($this.sortLoanStatus)
      this.$forceUpdate()
    },
    getRelatedLoans (input) {
      let flag = false
      for (const key in input) {
        if (input[key] !== this.input[key]) {
          flag = true
        }
      }
      const _this = this
      if (flag || this.search) {
        this.search = false
        this.input = input
        LoanOperationApi.customerSearch(input, function (data) {
          _this.relatedLoans = data
          _this.store.commit('setRelatedLoans', data)
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .script-content {
    margin: 5px 0 5px 0 !important;
    padding: 0 !important;
    .script-content-title {
      padding: 10px !important;
    }
    .script-content-text {
      padding: 0px 10px !important;
    }
  }
  .toolbar-card.v-sheet.v-toolbar:not(.v-sheet--outlined) {
    box-shadow: none;
  }
</style>
